// extracted by css-extract-rspack-plugin
export default {"ClearIcon":"mItsn"};